$(function(){
/*
	$('.edit-listing .group-cta a, .edit-listing .group-cta input').on('click',function(){
	});
*/
})
$(window).bind('load',function(){
	$('.edit-list-notification').each(function(){
		var el = $(this);
		setTimeout(function(){
			el.slideUp(300);
		},7000);
	});
});